import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { useSelector } from 'react-redux';
import Icon from 'src/components/App/Icon';

function LiveChatContainer() {
  const currentClinic = useSelector((state) => state.app.clinics?.currentClinic);

  const chatwootUrl = process.env.REACT_APP_CHATWOOT_URL || "https://chat.mycliniq.app/app/accounts/2/dashboard";

  const handleLaunchChat = () => {
    window.open(chatwootUrl, '_blank');
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 'calc(100vh - 70px)', p: 3 }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 3, maxWidth: 500 }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: 80, height: 80, color: '#25D366' }}>
            <Icon name="whatsapp" />
          </Box>
        </Box>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Live Chat Support
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          For security and best performance, your Live Chat dashboard opens in a separate secure window. Click the button below to connect with your patients.
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          size="large" 
          onClick={handleLaunchChat}
          sx={{ borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', fontSize: '1.1rem' }}
        >
          Launch Live Chat
        </Button>
      </Paper>
    </Box>
  );
}

export default LiveChatContainer;
